module.exports = __webpack_public_path__ + "img/图片4.bea32924.png";